export default "__VITE_ASSET__cb4b037d__"